module.exports = __webpack_public_path__ + "static/media/itang.19831c9a.jpg";